
import Login from './login/Login.vue'
import Error from './login/Error.vue'
import AreaSelect from "./area/areaSelect";

import UserIndex from './user/Index.vue'
import End from "./user/end";

const routes = [{
	path: '/index',
	component: UserIndex
},{
	path: '/area',
	component: AreaSelect
},,{
	path: '/end',
	component: End
},{
	path: '/error',
	component: Error
},{
	path: '/login',
	component: Login
}]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js